import {Autocomplete, createFilterOptions, TextField} from "@mui/material";
import * as React from "react";

interface CustomAutocompleteFreeSoloProps {
    watch: Function,
    setValue: Function,
    field: string,
    options: any[],
    label: string,
    placeholder: string,
    multiple: boolean
}

const CustomAutocompleteFreeSolo = ({watch, setValue, field, options, label, placeholder, multiple}: CustomAutocompleteFreeSoloProps) => {

    const filter = createFilterOptions<any>();

    return(
        <Autocomplete
            multiple={multiple}
            value={watch(field)}
            isOptionEqualToValue={(option, value) => {
                return option.toUpperCase() === value.toUpperCase();
            }}
            onChange={(event, newVal) => {
                let newList: string[] = [];
                newVal.map((val: string) => {
                    const found = options.find((option) => val.toUpperCase() === option.toUpperCase());
                    newList.push(found ? found : val);
                })
                setValue(field, newList)
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue.toUpperCase() === option.toUpperCase());
                if (inputValue !== '' && !isExisting) {
                    filtered.push(inputValue);
                }
                return filtered;
            }}
            clearOnBlur={true}
            blurOnSelect={false}
            handleHomeEndKeys={true}
            id={field}
            options={options}
            renderOption={(props, option) => <li {...props}>{option}</li>}
            freeSolo
            renderInput={(params) => (
                <TextField {...params} label={label} placeholder={placeholder} />
            )}
        />
    )
}
export default CustomAutocompleteFreeSolo;